export default function makeCancellablePromise(promise) {
    var isCancelled = false;
    var wrappedPromise = new Promise(function (resolve, reject) {
        promise
            .then(function (value) { return !isCancelled && resolve(value); })
            .catch(function (error) { return !isCancelled && reject(error); });
    });
    return {
        promise: wrappedPromise,
        cancel: function () {
            isCancelled = true;
        },
    };
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/make-cancellable-promise/dist/esm/index.js
// module id = 68
// module chunks = 1